var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6758 10.5L8.00912 2.33332C7.90737 2.15377 7.75981 2.00443 7.5815 1.90053C7.40319 1.79663 7.2005 1.74188 6.99413 1.74188C6.78775 1.74188 6.58507 1.79663 6.40675 1.90053C6.22844 2.00443 6.08088 2.15377 5.97913 2.33332L1.31246 10.5C1.20961 10.6781 1.15568 10.8803 1.15613 11.086C1.15659 11.2916 1.21141 11.4936 1.31505 11.6712C1.41869 11.8489 1.56746 11.996 1.74628 12.0976C1.9251 12.1993 2.12761 12.2518 2.33329 12.25H11.6666C11.8713 12.2498 12.0723 12.1957 12.2495 12.0932C12.4267 11.9908 12.5738 11.8435 12.6761 11.6661C12.7783 11.4888 12.8321 11.2877 12.8321 11.083C12.832 10.8783 12.7781 10.6773 12.6758 10.5Z",
    stroke: "#BB4D00",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.25V7.58333",
    stroke: "#BB4D00",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.91669H7.00583",
    stroke: "#BB4D00",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.732e0fa8077dc423c724c73fa0104e0f.svg";
export { ForwardRef as ReactComponent };